export const transition = {
  base: '0.3s',
  swift: '0.1s',
  expo: '1s cubic-bezier(.09,.88,.45,.96)',
};
